import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { FormField } from '@cp/ds/src/components/form';
import { useFormContext } from 'react-hook-form';
import { OTPAnswer } from '../model';

export interface OtpFormProps extends BoxProps, PropsWithChildren {
  length: number;
  sessionId?: string;
  resource?: string;
  deviceId?: string;
}
export const OtpForm: React.FC<OtpFormProps> = ({ length, sessionId, deviceId, resource, children, ...props }) => {
  const formRef = useRef<HTMLFormElement>(null);
  const otpInputRef = useRef<HTMLInputElement>(null);
  const { setValue, subscribe } = useFormContext<OTPAnswer>();

  useEffect(() => {
    return subscribe({
      name: ['code'],
      formState: { values: true },
      callback: ({ values }) => {
        if (values.code.length >= length) {
          formRef.current?.requestSubmit();
        }
      },
    });
  }, [subscribe, length]);

  useEffect(() => {
    const form = formRef.current as HTMLFormElement;
    if (!('OTPCredential' in window) || !form) {
      return;
    }
    const abortController = new AbortController();
    form.addEventListener('submit', abortController.abort);

    navigator.credentials
      // @ts-expect-error web otp typings
      .get({ signal: abortController.signal, otp: { transport: ['sms'] } })
      .then((otp: any) => {
        setValue('code', otp.code);
        form.requestSubmit();
      })
      .catch((err) => {
        if (err instanceof Error && err.name === 'NotSupportedError') {
          console.info(err);
        }
        form.removeEventListener('submit', abortController.abort);
        abortController.abort(err);
      });
    return () => {
      form.removeEventListener('submit', abortController.abort);
      abortController.abort('Component unmount');
    };
  }, []);

  return (
    <Box component="form" ref={formRef} {...props}>
      <FormField autoFocus inputSx={{ maxWidth: { xs: 'none', md: 292 } }} name="code" ref={otpInputRef} required type="sms" />
      <input name="resource" type="hidden" value={resource} />
      <input name="sessionId" type="hidden" value={sessionId} />
      <input name="deviceId" type="hidden" value={deviceId} />
      {children}
    </Box>
  );
};
